import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Input,
  Card,
  CardBody,
} from "reactstrap";
import DataTable from "react-data-table-component";
import {
  getProccesingCostByPlantId,
  addProccesingCost,
  deleteProcessingCost,
} from "../../../api/processing plant/plantApi";
import Swal from "sweetalert2";
import { motion } from "framer-motion";
import { AuthContext } from "../../ExtraPages/AuthProvider";
import { useContext } from "react";
import { getIdGivenUserId } from "../../../api/processing plant/plantApi";

const ProcessingPlantStockAccept = () => {
  const [costData, setCostData] = useState([]);
  const [filteredData, setFilteredData] = useState([]); // New state for filtered data
  const [modal, setModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [plantId, setPlantId] = useState([]);
  const [newCost, setNewCost] = useState({
    fishType: "",
    processingType: "",
    processingFee: 0,
    wastage: 0,
    _id: "",
  });
  const [filterFishType, setFilterFishType] = useState(""); // Filter for fishType
  const [filterProcessingType, setFilterProcessingType] = useState(""); // Filter for processingType

  const { user } = useContext(AuthContext);
  console.log("user", user.uid);

  useEffect(() => {
    const fetchPlantId = async () => {
      try {
        if (user) {
          const plantId = await getIdGivenUserId(user.uid);
          console.log("plantId", plantId.data);
          setPlantId(plantId.data);

          console.log("user", plantId.data);
        }
      } catch (error) {
        console.error("Error fetching plant ID:", error);
        // Optionally handle the error (e.g., set a default plantId or show a notification)
      }
    };

    fetchPlantId();
  }, [user]);

  const fetchPlantsStockData = async () => {
    try {
      const response = await getProccesingCostByPlantId(user.uid);
      console.log(response);
      if (Array.isArray(response.data.data)) {
        setCostData(response.data.data);
        setFilteredData(response.data.data); // Initialize filtered data
      } else {
        console.error("Unexpected response format:", response.data);
        setCostData([]);
        setFilteredData([]);
      }
    } catch (error) {
      console.error("Error fetching Cost:", error.message);
      setCostData([]);
      setFilteredData([]);
    }
  };

  useEffect(() => {
    fetchPlantsStockData();
  }, [plantId]);

  // Filter data based on fishType and processingType
  useEffect(() => {
    const filtered = costData.filter((item) => {
      const matchesFishType = filterFishType
        ? item.fishType.toLowerCase().includes(filterFishType.toLowerCase())
        : true;
      const matchesProcessingType = filterProcessingType
        ? item.processingType
            .toLowerCase()
            .includes(filterProcessingType.toLowerCase())
        : true;
      return matchesFishType && matchesProcessingType;
    });
    setFilteredData(filtered);
  }, [filterFishType, filterProcessingType, costData]);

  const toggleModal = () => setModal(!modal);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const updatedValue =
      name === "processingFee" || name === "wastage"
        ? parseFloat(value) || 0
        : value;
    setNewCost({ ...newCost, [name]: updatedValue });
  };

  const species = [
    {
      name: "Albacore",
      id: "alb",
    },
    {
      name: "Southern-bluefin-tuna",
      id: "sbt",
    },
    {
      name: "Big-eye-tuna",
      id: "bet",
    },
    {
      name: "Yellowfin-tuna",
      id: "yft",
    },
    {
      name: "Long-tail-tuna",
      id: "ltt",
    },
    {
      name: "Skip-jack-tuna",
      id: "sjt",
    },
    {
      name: "Kawa-kawa",
      id: "kk",
    },
    {
      name: "Frigate-tuna",
      id: "ft",
    },
    {
      name: "Bullet-tuna",
      id: "bt",
    },
    {
      name: "Narrow-barred-spanish-mackerel",
      id: "nbsm",
    },
    {
      name: "Indo-pacific-king-mackerel",
      id: "ipkm",
    },
    {
      name: "Wahoo",
      id: "wh",
    },
    {
      name: "Oil-fish",
      id: "of",
    },
    {
      name: "Escolar",
      id: "esc",
    },
    {
      name: "Common-dolphinfish",
      id: "cdf",
    },
    {
      name: "Great-barracuda",
      id: "gb",
    },
    {
      name: "Rainbow-runner",
      id: "rr",
    },
    {
      name: "Rough-trigger-fish",
      id: "rtf",
    },
    {
      name: "Atlantic-pomfret",
      id: "ap",
    },
  ];

  const handleSaveCost = async () => {
    try {
      console.log(plantId);
      if (editMode) {
        await addProccesingCost({ ...newCost, plantId: user.uid });
        Swal.fire("Success", "Processing cost updated successfully", "success");
      } else {
        await addProccesingCost({ ...newCost, plantId: user.uid });
        Swal.fire("Success", "Processing cost added successfully", "success");
      }
      toggleModal();
      fetchPlantsStockData();
    } catch (error) {
      console.error("Error saving cost:", error);
    }
  };

  const handleEdit = (row) => {
    setNewCost(row);
    setEditMode(true);
    toggleModal();
  };

  function getFishNameById(id) {
    const fish = species.find((f) => f.id === id);
    return fish ? fish.name : "Unknown Fish";
  }

  const columns = [
    { name: "#", selector: (row, index) => index + 1, sortable: true },
    {
      name: "Fish Type",
      selector: (row) => getFishNameById(row.fishType),
      sortable: true,
    },
    {
      name: "Processing Type",
      selector: (row) => row.processingType,
      sortable: true,
    },
    {
      name: "Processing Fee",
      selector: (row) => row.processingFee,
      sortable: true,
    },
    { name: "Wastage (%)", selector: (row) => row.wastage, sortable: true },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <button
            className="table-button table-button-success"
            size="sm"
            onClick={() => handleEdit(row)}
            style={{ marginRight: "4px" }}
          >
            Edit
          </button>
          <button
            className="table-button table-button-danger"
            size="sm"
            onClick={() => handleDelete(row._id)}
          >
            Delete
          </button>
        </>
      ),
    },
  ];

  const handleDelete = async (id) => {
    if (!id) {
      await Swal.fire("Error", "Invalid ID provided", "error");
      return false;
    }

    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "This processing cost will be permanently deleted!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
      });

      if (result.isConfirmed) {
        await deleteProcessingCost(id);
        await Swal.fire(
          "Deleted!",
          "Processing cost has been deleted.",
          "success"
        );
        try {
          await fetchPlantsStockData();
        } catch (fetchError) {
          console.error("Error fetching plants stock data:", fetchError);
        }
        return true;
      }
      return false;
    } catch (error) {
      await Swal.fire("Error", "Failed to delete processing cost", "error");
      console.error("Error deleting cost:", error);
      return false;
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5 }}
    >
      <div style={{ minHeight: '100%' }}>
        <Container fluid>
          <div style={{ overflowX: 'auto' }}>
            <Card style={{ backgroundColor: '#fff' }}>
              <CardBody style={{ padding: '20px' }}>
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h5 className="mb-0">Processing Cost</h5>
                  <Button
                    color="success"
                    onClick={() => {
                      setNewCost({
                        fishType: '',
                        processingType: '',
                        processingFee: 0,
                        wastage: 0,
                      });
                      setEditMode(false);
                      toggleModal();
                    }}
                  >
                    Add Cost
                  </Button>
                </div>

                {/* Filter Inputs */}
                <Row className="mb-3">
                  <Col md="6">
                    <FormGroup>
                      <Label for="filterFishType">Filter Fish Type</Label>
                      <Input
                        type="text"
                        name="filterFishType"
                        id="filterFishType"
                        placeholder="Enter fish type..."
                        value={filterFishType}
                        onChange={(e) => setFilterFishType(e.target.value)}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <Label for="filterProcessingType">
                        Filter Processing Type
                      </Label>
                      <Input
                        type="text"
                        name="filterProcessingType"
                        id="filterProcessingType"
                        placeholder="Enter processing type..."
                        value={filterProcessingType}
                        onChange={(e) =>
                          setFilterProcessingType(e.target.value)
                        }
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <DataTable
                  columns={columns}
                  data={filteredData} // Use filtered data instead of costData
                  pagination
                />
              </CardBody>
            </Card>
          </div>
        </Container>
      </div>

      {/* Add/Edit Cost Modal */}
      <Modal
        isOpen={modal}
        toggle={toggleModal}
      >
        <ModalHeader toggle={toggleModal}>
          {editMode ? 'Edit Processing Cost' : 'Add Processing Cost'}
        </ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label for="fishType">Fish Type</Label>
              <Input
                type="select"
                name="fishType"
                id="fishType"
                value={newCost.fishType}
                onChange={handleInputChange}
              >
                <option value="">Select Fish Type</option>
                {species.map((fish) => (
                  <option key={fish.id} value={fish.id}>
                    {fish.name.replace(/-/g, " ")}
                  </option>
                ))}

              </Input>
            </FormGroup>
            <FormGroup>
              <Label for="processingType">Processing Type</Label>
              <Input
                type="select"
                name="processingType"
                id="processingType"
                value={newCost.processingType}
                onChange={handleInputChange}
              >
                <option value="">Select Processing Type</option>
                <option value="Freezing">Freezing</option>
                <option value="Drying">Drying</option>
                <option value="Canning">Canning</option>
              </Input>
            </FormGroup>
            <FormGroup>
              <Label for="processingFee">Processing Fee</Label>
              <Input
                type="number"
                name="processingFee"
                id="processingFee"
                value={newCost.processingFee}
                onChange={handleInputChange}
              />
            </FormGroup>
            <FormGroup>
              <Label for="wastage">Wastage (%)</Label>
              <Input
                type="number"
                name="wastage"
                id="wastage"
                value={newCost.wastage}
                onChange={handleInputChange}
              />
            </FormGroup>
            <Button
              color="primary"
              onClick={handleSaveCost}
            >
              {editMode ? 'Update' : 'Add'}
            </Button>
          </Form>
        </ModalBody>
      </Modal>
    </motion.div>
  );
};

export default ProcessingPlantStockAccept;
